module.exports = __webpack_public_path__ + "static/media/hero.8449bb20.jpg";